import { normalizeReportLocale } from './locale';

const SEA_EDITOR_DICTIONARIES = {
  'vi-VN': {
    Markdown: 'Markdown',
    WYSIWYG: 'WYSIWYG',
    Write: 'Viết',
    Preview: 'Xem trước',
    Headings: 'Tiêu đề',
    Paragraph: 'Đoạn văn',
    Bold: 'In đậm',
    Italic: 'In nghiêng',
    Strike: 'Gạch ngang',
    Code: 'Mã',
    Line: 'Đường kẻ',
    Blockquote: 'Trích dẫn',
    'Unordered list': 'Danh sách không thứ tự',
    'Ordered list': 'Danh sách có thứ tự',
    Task: 'Nhiệm vụ',
    Indent: 'Tăng lề',
    Outdent: 'Giảm lề',
    'Insert link': 'Chèn liên kết',
    'Insert CodeBlock': 'Chèn khối mã',
    'Insert table': 'Chèn bảng',
    'Insert image': 'Chèn hình ảnh',
    Heading: 'Tiêu đề',
    'Image URL': 'URL hình ảnh',
    'Select image file': 'Chọn tệp hình ảnh',
    'Choose a file': 'Chọn tệp',
    'No file': 'Không có tệp',
    Description: 'Mô tả',
    OK: 'OK',
    More: 'Thêm',
    Cancel: 'Hủy',
    File: 'Tệp',
    URL: 'URL',
    'Link text': 'Văn bản liên kết',
    'Add row to up': 'Thêm hàng phía trên',
    'Add row to down': 'Thêm hàng phía dưới',
    'Add column to left': 'Thêm cột bên trái',
    'Add column to right': 'Thêm cột bên phải',
    'Remove row': 'Xóa hàng',
    'Remove column': 'Xóa cột',
    'Align column to left': 'Căn cột sang trái',
    'Align column to center': 'Căn cột vào giữa',
    'Align column to right': 'Căn cột sang phải',
    'Remove table': 'Xóa bảng',
    'Would you like to paste as table?': 'Bạn có muốn dán dưới dạng bảng không?',
    'Text color': 'Màu chữ',
    'Auto scroll enabled': 'Đã bật cuộn tự động',
    'Auto scroll disabled': 'Đã tắt cuộn tự động',
    'Choose language': 'Chọn ngôn ngữ',
  },
  'th-TH': {
    Markdown: 'Markdown',
    WYSIWYG: 'WYSIWYG',
    Write: 'เขียน',
    Preview: 'แสดงตัวอย่าง',
    Headings: 'หัวข้อ',
    Paragraph: 'ย่อหน้า',
    Bold: 'ตัวหนา',
    Italic: 'ตัวเอียง',
    Strike: 'ขีดฆ่า',
    Code: 'โค้ด',
    Line: 'เส้นคั่น',
    Blockquote: 'ข้อความอ้างอิง',
    'Unordered list': 'รายการไม่มีลำดับ',
    'Ordered list': 'รายการมีลำดับ',
    Task: 'งาน',
    Indent: 'เพิ่มระยะย่อหน้า',
    Outdent: 'ลดระยะย่อหน้า',
    'Insert link': 'แทรกลิงก์',
    'Insert CodeBlock': 'แทรกบล็อกโค้ด',
    'Insert table': 'แทรกตาราง',
    'Insert image': 'แทรกรูปภาพ',
    Heading: 'หัวข้อ',
    'Image URL': 'URL รูปภาพ',
    'Select image file': 'เลือกไฟล์รูปภาพ',
    'Choose a file': 'เลือกไฟล์',
    'No file': 'ไม่มีไฟล์',
    Description: 'คำอธิบาย',
    OK: 'ตกลง',
    More: 'เพิ่มเติม',
    Cancel: 'ยกเลิก',
    File: 'ไฟล์',
    URL: 'URL',
    'Link text': 'ข้อความลิงก์',
    'Add row to up': 'เพิ่มแถวขึ้นด้านบน',
    'Add row to down': 'เพิ่มแถวด้านล่าง',
    'Add column to left': 'เพิ่มคอลัมน์ทางซ้าย',
    'Add column to right': 'เพิ่มคอลัมน์ทางขวา',
    'Remove row': 'ลบแถว',
    'Remove column': 'ลบคอลัมน์',
    'Align column to left': 'จัดคอลัมน์ชิดซ้าย',
    'Align column to center': 'จัดคอลัมน์กึ่งกลาง',
    'Align column to right': 'จัดคอลัมน์ชิดขวา',
    'Remove table': 'ลบตาราง',
    'Would you like to paste as table?': 'ต้องการวางเป็นตารางหรือไม่?',
    'Text color': 'สีข้อความ',
    'Auto scroll enabled': 'เปิดการเลื่อนอัตโนมัติ',
    'Auto scroll disabled': 'ปิดการเลื่อนอัตโนมัติ',
    'Choose language': 'เลือกภาษา',
  },
  'id-ID': {
    Markdown: 'Markdown',
    WYSIWYG: 'WYSIWYG',
    Write: 'Tulis',
    Preview: 'Pratinjau',
    Headings: 'Judul',
    Paragraph: 'Paragraf',
    Bold: 'Tebal',
    Italic: 'Miring',
    Strike: 'Coret',
    Code: 'Kode',
    Line: 'Garis',
    Blockquote: 'Kutipan Blok',
    'Unordered list': 'Daftar tidak berurutan',
    'Ordered list': 'Daftar berurutan',
    Task: 'Tugas',
    Indent: 'Tambah Indentasi',
    Outdent: 'Kurangi Indentasi',
    'Insert link': 'Sisipkan tautan',
    'Insert CodeBlock': 'Sisipkan Blok Kode',
    'Insert table': 'Sisipkan tabel',
    'Insert image': 'Sisipkan gambar',
    Heading: 'Judul',
    'Image URL': 'URL Gambar',
    'Select image file': 'Pilih file gambar',
    'Choose a file': 'Pilih file',
    'No file': 'Tidak ada file',
    Description: 'Deskripsi',
    OK: 'OK',
    More: 'Lainnya',
    Cancel: 'Batal',
    File: 'File',
    URL: 'URL',
    'Link text': 'Teks tautan',
    'Add row to up': 'Tambah baris di atas',
    'Add row to down': 'Tambah baris di bawah',
    'Add column to left': 'Tambah kolom di kiri',
    'Add column to right': 'Tambah kolom di kanan',
    'Remove row': 'Hapus baris',
    'Remove column': 'Hapus kolom',
    'Align column to left': 'Ratakan kolom ke kiri',
    'Align column to center': 'Ratakan kolom ke tengah',
    'Align column to right': 'Ratakan kolom ke kanan',
    'Remove table': 'Hapus tabel',
    'Would you like to paste as table?': 'Apakah Anda ingin menempelkan sebagai tabel?',
    'Text color': 'Warna teks',
    'Auto scroll enabled': 'Gulir otomatis diaktifkan',
    'Auto scroll disabled': 'Gulir otomatis dinonaktifkan',
    'Choose language': 'Pilih bahasa',
  },
  'ms-MY': {
    Markdown: 'Markdown',
    WYSIWYG: 'WYSIWYG',
    Write: 'Tulis',
    Preview: 'Pratonton',
    Headings: 'Tajuk',
    Paragraph: 'Perenggan',
    Bold: 'Tebal',
    Italic: 'Condong',
    Strike: 'Coret',
    Code: 'Kod sebaris',
    Line: 'Garis',
    Blockquote: 'Petikan blok',
    'Unordered list': 'Senarai tidak bernombor',
    'Ordered list': 'Senarai bernombor',
    Task: 'Tugas',
    Indent: 'Tambah inden',
    Outdent: 'Kurangkan inden',
    'Insert link': 'Masukkan pautan',
    'Insert CodeBlock': 'Masukkan Blok Kod',
    'Insert table': 'Masukkan jadual',
    'Insert image': 'Masukkan imej',
    Heading: 'Tajuk',
    'Image URL': 'URL Imej',
    'Select image file': 'Pilih fail imej',
    'Choose a file': 'Pilih fail',
    'No file': 'Tiada fail',
    Description: 'Keterangan',
    OK: 'OK',
    More: 'Lagi',
    Cancel: 'Batal',
    File: 'Fail',
    URL: 'URL',
    'Link text': 'Teks pautan',
    'Add row to up': 'Tambah baris di atas',
    'Add row to down': 'Tambah baris di bawah',
    'Add column to left': 'Tambah lajur di kiri',
    'Add column to right': 'Tambah lajur di kanan',
    'Remove row': 'Buang baris',
    'Remove column': 'Buang lajur',
    'Align column to left': 'Jajarkan lajur ke kiri',
    'Align column to center': 'Jajarkan lajur ke tengah',
    'Align column to right': 'Jajarkan lajur ke kanan',
    'Remove table': 'Buang jadual',
    'Would you like to paste as table?': 'Adakah anda ingin menampal sebagai jadual?',
    'Text color': 'Warna teks',
    'Auto scroll enabled': 'Tatal automatik didayakan',
    'Auto scroll disabled': 'Tatal automatik dilumpuhkan',
    'Choose language': 'Pilih bahasa',
  },
};

// Toast UI does not ship a Russian dictionary in this bundle. Keep the full
// toolbar vocabulary available with Russian labels so the consultation editor
// does not fall back to a Southeast Asian dictionary for any command.
SEA_EDITOR_DICTIONARIES['ru-RU'] = {
  Markdown: 'Markdown',
  WYSIWYG: 'WYSIWYG',
  Write: 'Написать',
  Preview: 'Предпросмотр',
  Headings: 'Заголовки',
  Paragraph: 'Абзац',
  Bold: 'Полужирный',
  Italic: 'Курсив',
  Strike: 'Зачёркивание',
  Code: 'Код',
  Line: 'Линия',
  Blockquote: 'Цитата',
  'Unordered list': 'Маркированный список',
  'Ordered list': 'Нумерованный список',
  Task: 'Задача',
  Indent: 'Увеличить отступ',
  Outdent: 'Уменьшить отступ',
  'Insert link': 'Вставить ссылку',
  'Insert CodeBlock': 'Вставить блок кода',
  'Insert table': 'Вставить таблицу',
  'Insert image': 'Вставить изображение',
  Heading: 'Заголовок',
  'Image URL': 'URL изображения',
  'Select image file': 'Выбрать файл изображения',
  'Choose a file': 'Выбрать файл',
  'No file': 'Нет файла',
  Description: 'Описание',
  OK: 'ОК',
  More: 'Ещё',
  Cancel: 'Отмена',
  File: 'Файл',
  URL: 'URL',
  'Link text': 'Текст ссылки',
  'Add row to up': 'Добавить строку выше',
  'Add row to down': 'Добавить строку ниже',
  'Add column to left': 'Добавить столбец слева',
  'Add column to right': 'Добавить столбец справа',
  'Remove row': 'Удалить строку',
  'Remove column': 'Удалить столбец',
  'Align column to left': 'Выровнять столбец по левому краю',
  'Align column to center': 'Выровнять столбец по центру',
  'Align column to right': 'Выровнять столбец по правому краю',
  'Remove table': 'Удалить таблицу',
  'Would you like to paste as table?': 'Вставить как таблицу?',
  'Text color': 'Цвет текста',
  'Auto scroll enabled': 'Автопрокрутка включена',
  'Auto scroll disabled': 'Автопрокрутка отключена',
  'Choose language': 'Выбрать язык',
};

const EDITOR_LANGUAGE_BY_LOCALE = {
  'en-US': 'en-US',
  'ar-SA': 'ar',
  'zh-CN': 'zh-CN',
  'zh-HK': 'zh-TW',
  'zh-TW': 'zh-TW',
  'zh-MO': 'zh-TW',
  'vi-VN': 'vi-VN',
  'th-TH': 'th-TH',
  'id-ID': 'id-ID',
  'ms-MY': 'ms-MY',
  'ru-RU': 'ru-RU',
};

const HISTORY_LABELS = {
  'en-US': { undo: 'Undo', redo: 'Redo' },
  'ar-SA': { undo: 'تراجع', redo: 'إعادة' },
  'zh-CN': { undo: '撤销', redo: '重做' },
  'zh-HK': { undo: '復原', redo: '重做' },
  'zh-TW': { undo: '復原', redo: '重做' },
  'zh-MO': { undo: '復原', redo: '重做' },
  'vi-VN': { undo: 'Hoàn tác', redo: 'Làm lại' },
  'th-TH': { undo: 'เลิกทำ', redo: 'ทำซ้ำ' },
  'id-ID': { undo: 'Urungkan', redo: 'Ulangi' },
  'ms-MY': { undo: 'Undur', redo: 'Buat semula' },
  'ru-RU': { undo: 'Отменить', redo: 'Повторить' },
};

let editorLocalesRegistered = false;

export const registerEditorLocales = (Editor) => {
  if (editorLocalesRegistered || typeof Editor?.setLanguage !== 'function') {
    return;
  }
  Object.entries(SEA_EDITOR_DICTIONARIES).forEach(([locale, dictionary]) => {
    Editor.setLanguage(locale, dictionary);
  });
  editorLocalesRegistered = true;
};

export const getEditorLanguage = (locale) => (
  EDITOR_LANGUAGE_BY_LOCALE[normalizeReportLocale(locale)] || 'en-US'
);

export const getEditorHistoryLabels = (locale) => (
  HISTORY_LABELS[normalizeReportLocale(locale)] || HISTORY_LABELS['en-US']
);

export { SEA_EDITOR_DICTIONARIES };
